@switch (input.style | parse: context | async) {
  @case ('basic') {
    @if (input.external) {
      <a
        mat-button
        [color]="color | parse: context | async"
        [disabled]="input.disabled | parse: context | async"
        [href]="input.url | parse: context | async"
        target="_blank"
      >
        @if (input.icon | parse: context | async; as icon) {
          <mat-icon>
            {{ icon }}
          </mat-icon>
        }
        @if (input.text | parse: context | async; as text) {
          <span> {{ text }} </span>
        }
      </a>
    }
    @if (!input.external) {
      <a
        mat-button
        [color]="color | parse: context | async"
        [disabled]="input.disabled | parse: context | async"
        [routerLink]="input.url | parse: context | async"
        [queryParams]="input.queryParams | parse: context | async"
      >
        @if (input.icon | parse: context | async; as icon) {
          <mat-icon>
            {{ icon }}
          </mat-icon>
        }
        @if (input.text | parse: context | async; as text) {
          <span> {{ text }} </span>
        }
      </a>
    }
  }
  @case ('raised') {
    @if (input.external) {
      <a
        mat-raised-button
        [color]="color | parse: context | async"
        [disabled]="input.disabled | parse: context | async"
        [href]="input.url | parse: context | async"
        target="_blank"
      >
        @if (input.icon | parse: context | async; as icon) {
          <mat-icon>
            {{ icon }}
          </mat-icon>
        }
        @if (input.text | parse: context | async; as text) {
          <span> {{ text }} </span>
        }
      </a>
    }
    @if (!input.external) {
      <a
        mat-raised-button
        [color]="color | parse: context | async"
        [disabled]="input.disabled | parse: context | async"
        [routerLink]="input.url | parse: context | async"
        [queryParams]="input.queryParams | parse: context | async"
      >
        @if (input.icon | parse: context | async; as icon) {
          <mat-icon>
            {{ icon }}
          </mat-icon>
        }
        @if (input.text | parse: context | async; as text) {
          <span> {{ text }} </span>
        }
      </a>
    }
  }
  @case ('stroked') {
    @if (input.external) {
      <a
        mat-stroked-button
        [color]="color | parse: context | async"
        [disabled]="input.disabled | parse: context | async"
        [href]="input.url | parse: context | async"
        target="_blank"
      >
        @if (input.icon | parse: context | async; as icon) {
          <mat-icon>
            {{ icon }}
          </mat-icon>
        }
        @if (input.text | parse: context | async; as text) {
          <span> {{ text }} </span>
        }
      </a>
    }
    @if (!input.external) {
      <a
        mat-stroked-button
        [color]="color | parse: context | async"
        [disabled]="input.disabled | parse: context | async"
        [routerLink]="input.url | parse: context | async"
        [queryParams]="input.queryParams | parse: context | async"
      >
        @if (input.icon | parse: context | async; as icon) {
          <mat-icon>
            {{ icon }}
          </mat-icon>
        }
        @if (input.text | parse: context | async; as text) {
          <span> {{ text }} </span>
        }
      </a>
    }
  }
  @case ('flat') {
    @if (input.external) {
      <a
        mat-flat-button
        [color]="color | parse: context | async"
        [disabled]="input.disabled | parse: context | async"
        [href]="input.url | parse: context | async"
        target="_blank"
      >
        @if (input.icon | parse: context | async; as icon) {
          <mat-icon>
            {{ icon }}
          </mat-icon>
        }
        @if (input.text | parse: context | async; as text) {
          <span> {{ text }} </span>
        }
      </a>
    }
    @if (!input.external) {
      <a
        mat-flat-button
        [color]="color | parse: context | async"
        [disabled]="input.disabled | parse: context | async"
        [routerLink]="input.url | parse: context | async"
        [queryParams]="input.queryParams | parse: context | async"
      >
        @if (input.icon | parse: context | async; as icon) {
          <mat-icon>
            {{ icon }}
          </mat-icon>
        }
        @if (input.text | parse: context | async; as text) {
          <span> {{ text }} </span>
        }
      </a>
    }
  }
  @case ('icon') {
    @if (input.external) {
      <a
        mat-icon-button
        [color]="color | parse: context | async"
        [disabled]="input.disabled | parse: context | async"
        [href]="input.url | parse: context | async"
        target="_blank"
      >
        @if (input.icon | parse: context | async; as icon) {
          <mat-icon>
            {{ icon }}
          </mat-icon>
        }
        @if (input.text | parse: context | async; as text) {
          <span> {{ text }} </span>
        }
      </a>
    }
    @if (!input.external) {
      <a
        mat-icon-button
        [color]="color | parse: context | async"
        [disabled]="input.disabled | parse: context | async"
        [routerLink]="input.url | parse: context | async"
        [queryParams]="input.queryParams | parse: context | async"
      >
        @if (input.icon | parse: context | async; as icon) {
          <mat-icon>
            {{ icon }}
          </mat-icon>
        }
        @if (input.text | parse: context | async; as text) {
          <span> {{ text }} </span>
        }
      </a>
    }
  }
  @case ('fab') {
    @if (input.external) {
      <a
        mat-fab
        [color]="color | parse: context | async"
        [disabled]="input.disabled | parse: context | async"
        [href]="input.url | parse: context | async"
        target="_blank"
      >
        @if (input.icon | parse: context | async; as icon) {
          <mat-icon>
            {{ icon }}
          </mat-icon>
        }
        @if (input.text | parse: context | async; as text) {
          <span> {{ text }} </span>
        }
      </a>
    }
    @if (!input.external) {
      <a
        mat-fab
        [color]="color | parse: context | async"
        [disabled]="input.disabled | parse: context | async"
        [routerLink]="input.url | parse: context | async"
        [queryParams]="input.queryParams | parse: context | async"
      >
        @if (input.icon | parse: context | async; as icon) {
          <mat-icon>
            {{ icon }}
          </mat-icon>
        }
        @if (input.text | parse: context | async; as text) {
          <span> {{ text }} </span>
        }
      </a>
    }
  }
  @case ('mini-fab') {
    @if (input.external) {
      <a
        mat-mini-fab
        [color]="color | parse: context | async"
        [disabled]="input.disabled | parse: context | async"
        [href]="input.url | parse: context | async"
        target="_blank"
      >
        @if (input.icon | parse: context | async; as icon) {
          <mat-icon>
            {{ icon }}
          </mat-icon>
        }
        @if (input.text | parse: context | async; as text) {
          <span> {{ text }} </span>
        }
      </a>
    }
    @if (!input.external) {
      <a
        mat-mini-fab
        [color]="color | parse: context | async"
        [disabled]="input.disabled | parse: context | async"
        [routerLink]="input.url | parse: context | async"
        [queryParams]="input.queryParams | parse: context | async"
      >
        @if (input.icon | parse: context | async; as icon) {
          <mat-icon>
            {{ icon }}
          </mat-icon>
        }
        @if (input.text | parse: context | async; as text) {
          <span> {{ text }} </span>
        }
      </a>
    }
  }
}
